<div class="header-c">
<!-- <div class="header-c" [style.font-size]="textSize"> -->
    Posición de precio VS competencia
</div>
<div *ngIf="reqst===1" class="text-center loader-container">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div *ngIf="reqst===2">
    <div>
        <highcharts-chart class="chart" id="mychart5" [Highcharts]="Highcharts" [options]="chartOptions"></highcharts-chart>
    </div>
</div>
